import config from '../config/index'
import {
  CustomerServiceUserProfile,
  CustomerServiceUserProfileParams,
} from '../pages/public/customer-service-user-profile/share-types'
import { authRequest } from '../request'

const { mainApi } = config

export const getCustomerServiceUserProfile = (params: CustomerServiceUserProfileParams) =>
  authRequest.get<MISSING_TYPE, CustomerServiceUserProfile>(
    `${mainApi}/customer-service/user-profile`,
    { params },
  )
